import { Blog } from 'entities/blog'
import { StandardVertical } from 'entities/vertical'
import { routes } from 'routes'
import { emoji } from 'lib/emoji'
import { toImgixUrl } from 'lib/imgix'
import { canonicalUrl as seoCanonicalUrl } from 'lib/seo'
import { capitalize, pluralize } from 'lib/text'
import { allVerticalsConfig } from 'lib/vertical'
import { BlogForBlogPage } from 'containers/blogs/queries'

export const canonicalUrl = (
    vertical: StandardVertical,
    blog: Pick<Blog, 'id' | 'primaryVertical' | 'originalSource'>,
) => {
    return (
        blog.originalSource ?? seoCanonicalUrl(vertical, routes.article({ id: blog.id }))
    )
}
export const openGraphImage = (blog: Pick<Blog, 'feature'>) =>
    blog.feature ? toImgixUrl(blog.feature, { w: 520, ar: '16:9' }) : '#'

export const twitterData = (
    blog: Pick<BlogForBlogPage, 'readingTime' | 'tags'>,
): [string, string][] => {
    return [
        [
            'Reading time',
            emoji.clock +
                ' ' +
                blog.readingTime +
                ' ' +
                pluralize(blog.readingTime, 'min'),
        ],
        ['Tags', emoji.rocket + ' ' + blog.tags.map(t => capitalize(t.label)).join(', ')],
    ]
}

export const keywords = (vertical: StandardVertical, blog: Pick<Blog, 'tags'>) => {
    return [
        allVerticalsConfig[vertical].labelName + ' article',
        ...blog.tags.map(t => t.label),
    ]
}
